import {
  fetchHomeFund, fetchHomeStat, fetchEnable, fetchHomeStatTrend, fetchHomeStatTrendSingle,
  createSponsorApply,exportHomeData, getExportHomeDataStatus, cancelExportHomeData,
} from '../services/api';
// import { message } from 'antd';

const exportReport = {
  homeData: {
    getStatus: getExportHomeDataStatus, 
    cancelExport: cancelExportHomeData,
    submitExport: exportHomeData,
  },
}

const fetchLine = {
  single: fetchHomeStatTrendSingle,
  global: fetchHomeStatTrend,
}

export default {
  namespace: 'home',
  state: {
    fundData: {},
    sponsorData: {},
    adListData: [],
  },

  effects: {
    *fetchCommon(_, { call, put, all }) {
      const [responseFund, responseList] = yield all([
        call(fetchHomeFund),
        call(fetchEnable),
      ])
      yield put({ type: 'loadHomeFund', payload: responseFund })
      yield put({ type: 'loadEnable', payload: responseList })
    },

    *fetchStatistic({ payload }, { call, put }) {
      const resHomeData = yield call(fetchHomeStat, payload)
      yield put({ type: 'loadHomeSponsor', payload: resHomeData })
    },

    *fetchLine({ payload, scope }, { call }) {
      // alert(field)
      // alert(JSON.stringify(payload));
      if (!(scope in fetchLine)) return
      const { metrics } = payload
      const response = yield call(fetchLine[scope], payload);
      return (metrics || []).map(() => ({ list: (response || []).map(item => ({ ...item, dateTime: (item || {}).day, totalCost: (item || {}).cost })) }))
    },
    
    
    *exportReport({ payload, field, action }, { call }) {
      const response = yield call(exportReport[field][action], payload);
      return response
    },

    *createSponsorApply({ payload, callback }, { call, put }) { // 首页注册用
      const response = yield call(createSponsorApply, payload);
      if (response) {
        callback(response);
      }
    },
  },

  reducers: {
    loadHomeFund(state, { payload }) {
      const fundData = { ...state.fundData, ...payload };
      return {
        ...state,
        fundData,
      };
    },
    loadHomeSponsor(state, { payload }) {
      return {
        ...state,
        sponsorData: payload || {},
      };
    },
    loadEnable(state, { payload }) {
      const adListData = Array.isArray(payload) ? payload : [];
      return {
        ...state,
        adListData,
      };
    },
    loadSingle(state, { payload }) {
      const singleData = { ...state.singleData, ...payload };
      const adConstant = payload.campaignPackage.individuationConstantVO;
      return {
        ...state,
        singleData,
        adConstant,
      };
    },
    loadStatTrend(state, { payload }) {
      const salesData = { ...state.salesData, ...payload };
      return {
        ...state, salesData,
      };
    },
    clear() {
      return {
        fundData: {},
        sponsorData: {},
        singleData: {},
        salesData: [],
        adListData: [],
      };
    },
  },
};
